import { COULEURS } from '../../app/styles.js';
import type { ReglageEstimation, RoleExterne } from './types.js';

export interface EstimationExterne {
  reglage: ReglageEstimation;
  lignes: readonly { libelle: string; valeur: string }[];
}

export const MENTION_ESTIMATION = 'Estimation indicative, ne vaut pas évaluation';

/** Clé du réglage appris par la question BETA-16 (#56). */
export const CLE_REGLAGE_ESTIMATION = 'estimation.visible_clerc_notaire';

/** Par défaut, l’estimation est réservée à l’équipe MAAT. */
export function estimationVisible(role: RoleExterne, reglage: ReglageEstimation): boolean {
  if (reglage === 'clerc_notaire') return true;
  return reglage === 'clerc' && role === 'clerc';
}

export function lireReglageEstimation(reglages: readonly { key: string; value: unknown }[]): ReglageEstimation {
  const valeur = reglages.find((r) => r.key === CLE_REGLAGE_ESTIMATION)?.value;
  return valeur === 'clerc' || valeur === 'clerc_notaire' ? valeur : 'jamais';
}

export function BlocEstimation({
  role,
  reglage,
  lignes,
}: {
  role: RoleExterne;
  reglage: ReglageEstimation;
  lignes: EstimationExterne['lignes'];
}) {
  if (!estimationVisible(role, reglage)) return null;
  return (
    <section aria-labelledby="titre-estimation">
      <h2 id="titre-estimation">Estimation</h2>
      <dl>
        {lignes.map((l) => (
          <div key={l.libelle}>
            <dt>{l.libelle}</dt>
            <dd>{l.valeur}</dd>
          </div>
        ))}
      </dl>
      <p style={{ color: COULEURS.ardoise }}>{MENTION_ESTIMATION}</p>
    </section>
  );
}
